import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Flex,
  Icon,
  IconButton,
  MenuItem,
  MenuList,
  Spinner,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  useToast,
  Tooltip,
  Tr,
  useBreakpointValue,
  useDisclosure,
  MenuButton,
  MenuGroup,
  MenuDivider,
  Menu,
  Button,
  HStack,
  Checkbox,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import {
  FiChevronDown,
  FiDownload,
  FiMoreVertical,
  FiSearch,
} from 'react-icons/fi';
import { Link, useHistory, useLocation } from 'react-router-dom';
import download from 'downloadjs';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { MultiSelect } from 'react-multi-select-component';
import { Stack } from '@chakra-ui/layout';
import { DocumentsForm } from '~/pages/Portal/Documents/DocumentsForm';
import { PAGE_SIZE, STORAGE } from '~/constants';
import { useSidebar } from '~/hooks/useSidebar';
import { Heading, Input, Pagination, Table } from '~/components';
import { useDebounce, useQueryParams, useRoleCan } from '~/hooks';
import {
  useAllDocumentsTypes,
  useDocumentDelete,
  useDocumentsList,
} from '~/hooks/useDocuments/useDocuments';
import { formatInTimeZone } from '~/utils/formatToTimeZone';
import {
  downloadDocument,
  downloadSelectedDocuments,
  getDocumentsXlsxCsv,
} from '~/services/Documents';
import { FilterContext } from '~/contexts/FilterContext/FilterContext';
import { updateUrlParams } from '~/utils/updateUrlParams';
import { Documents as DocumentsType } from '~/types/documents';
import { DownloadContext } from '~/contexts/DownloadContext/DownloadContext';
import { SelectItem } from '~/types';
import { MultiSelectStrings } from '~/utils/multiSelectStrings';
import { queryClient } from '~/utils/react-query';
import { useFeatureFlags } from '~/contexts/FeatureFlagsContext/FeatureFlagsContext';

type Config = {
  documentsIsOpen: boolean;
};

export const Documents: React.VFC = () => {
  const queryParams = useQueryParams();
  const history = useHistory();
  const location = useLocation();
  const features = useFeatureFlags();

  const [searchTmp, setSearchTmp] = useState(() => {
    return queryParams.get('busca') ?? '';
  });

  const [idDocumento, setId] = useState<number>(0);
  const toast = useToast();
  const deleteDocumento = useDocumentDelete();
  const { groups, headOffices, branches } = useContext(FilterContext);
  const { isActive, apply } = useContext(DownloadContext);
  const [parametros, setParametros] = useState(() => {
    return {
      busca: queryParams.get('busca') ?? '',
      pagina: queryParams.get('pagina') ?? '1',
      paginacao: queryParams.get('paginacao') ?? PAGE_SIZE.toString(),
      order: queryParams.get('order') ?? '',
      orderBy: queryParams.get('orderBy') ?? '',
    };
  });
  const [isLoadingDownload, setIsLoadingDownload] = useState(false);
  const [isLoadingDownloadSelected, setIsLoadingDownloadSelected] =
    useState(false);
  const [selectedTypes, setSelectedTypes] = useState<SelectItem[]>([]);

  const { data, isLoading, isFetching, refetch, isError } = useDocumentsList(
    Number(parametros.pagina) ?? 1,
    parametros.orderBy,
    parametros.order,
    parametros.busca,
    selectedTypes.map(e => Number(e.value)),
    { groups, headOffices, branches },
    {
      onSuccess: r => {
        setListaDocumentos(r.results);
        // clearDownloadAllDocuments();
        setDocumentosSelecionados([]);
        setSelecionarTodosDocumentosPagina(false);
        setDownloadAllDocuments(false);
      },
    },
    Number(parametros.paginacao),
  );
  const { isOpen, onToggle } = useSidebar();
  const isDocumentsSidebar = useBreakpointValue({
    base: true,
    lg: false,
  });
  const hasPermission = useRoleCan({ roles: ['administrador', 'operacional'] });
  const hasNotPermissionRemove = ['Apólice seguradora'];

  const {
    isOpen: isDialogOpen,
    onOpen: onDialogOpen,
    onClose: onDialogClose,
  } = useDisclosure();

  function setConfig() {
    localStorage.setItem(
      `${STORAGE}.config`,
      JSON.stringify({ documentsIsOpen: isOpen }),
    );
  }

  const [selecionarTodosDocumentosPagina, setSelecionarTodosDocumentosPagina] =
    useState(false);
  const [downloadAllDocuments, setDownloadAllDocuments] = useState(false);
  const [documentosSelecionados, setDocumentosSelecionados] = useState<
    number[]
  >([]);
  const [listaDocumentos, setListaDocumentos] = useState<DocumentsType[]>([]);

  const [typeOptions, setTypeOptions] = useState<SelectItem[]>([]);
  const { data: dataTypes, isLoading: isTypesLoading } = useAllDocumentsTypes({
    onSuccess: r => {
      const t = r.results.map(e => ({
        label: e.nome,
        value: e.id_tipo.toString(),
      }));
      setTypeOptions(t);
    },
  });

  const [tipoArquivo, setTipoArquivo] = useState(0);

  useEffect(() => {
    refetch();
  }, [parametros.pagina]);

  function handleDialog(id: number) {
    setId(id);
    onDialogOpen();
  }

  function handleDelete() {
    deleteDocumento.mutateAsync(idDocumento);
    onDialogClose();
    refetch();
    if (Number(parametros.pagina) > 1 && data) {
      const listEmpty =
        (data.count - 1) / (Number(parametros.pagina) - 1) === 10;
      listEmpty
        ? setParametros({
            ...parametros,
            pagina: (Number(parametros.pagina) - 1).toString(),
          })
        : '';
    }
  }

  useDebounce(
    () => {
      setParametros({
        ...parametros,
        busca: searchTmp,
        pagina: '1',
      });
      updateUrlParams(
        { ...parametros, busca: searchTmp, pagina: '1' },
        history,
      );
      refetch();
    },
    1000,
    [searchTmp],
  );

  useEffect(() => {
    refetch();
    const { documentsIsOpen }: Config = JSON.parse(
      localStorage.getItem(`${STORAGE}.config`) || '{}',
    );

    if (documentsIsOpen) {
      if (isOpen !== documentsIsOpen) onToggle();
    } else {
      setConfig();
    }
  }, []);

  useEffect(() => {
    // setPage(1);
    setParametros({
      ...parametros,
      pagina: queryParams.get('pagina') ?? '1',
    });
    updateUrlParams({ ...parametros, pagina: '1' }, history);
    refetch();
  }, [groups, headOffices, branches]);

  useEffect(() => {
    const pagina = queryParams.get('pagina');
    setParametros({
      ...parametros,
      pagina: pagina ?? '1',
      order: queryParams.get('order') ?? sortDirection,
      orderBy: queryParams.get('orderBy') ?? sortField,
    });
    updateUrlParams(
      {
        ...parametros,
        pagina: pagina ?? '1',
        order: queryParams.get('order') ?? sortDirection,
        orderBy: queryParams.get('orderBy') ?? sortField,
      },
      history,
    );
  }, [location.search]);

  const routeChange = (num: number) => {
    const path = `/portal/contracts/${num}`;
    history.push(path);
  };

  function handleDocumentDownload(id: number) {
    downloadDocument(id)
      .then(r => {
        if (r?.data?.size > 0) {
          download(
            new Blob([r.data], { type: r.data.type }),
            r.headers['content-disposition'].match(/filename="(.+)"/)[1],
          );
        } else {
          toast({
            title: r?.data?.error,
            description: 'Entre em contato para mais informações',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
      })
      .catch(() => {
        toast({
          title: 'Documento não encontrado',
          description: 'Entre em contato para mais informações',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      });
  }

  const [sortField, setSortField] = useState(
    queryParams.get('orderBy') ?? 'data_cadastro',
  );
  const [sortDirection, setSortDirection] = useState(
    queryParams.get('order') ?? 'DESC',
  );

  function handleDocumentOrder(field: string) {
    setSortField(field);
    setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC');
  }

  useEffect(() => {
    setParametros({
      ...parametros,
      order: sortDirection,
      orderBy: sortField,
      pagina: queryParams.get('pagina') ?? '1',
    });
    updateUrlParams(
      {
        ...parametros,
        order: sortDirection,
        orderBy: sortField,
        pagina: queryParams.get('pagina') ?? '1',
      },
      history,
    );
  }, [sortField, sortDirection]);

  const getDirection = (key: string) => {
    return sortField === key ? sortDirection : undefined;
  };

  const handlePageSizeChange = (e: any) => {
    clearDownloadAllDocuments();
    setParametros({
      ...parametros,
      paginacao: e.target.value,
      pagina: '1',
      order: sortDirection,
      orderBy: sortField,
    });
    updateUrlParams(
      {
        ...parametros,
        paginacao: e.target.value,
        pagina: '1',
        order: sortDirection,
        orderBy: sortField,
      },
      history,
    );
  };

  const handleDownload = async () => {
    if (!selectedTypes.length) {
      toast({
        title: 'Selecione ao menos um tipo de documento',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      return;
    }
    const ids_tipos = selectedTypes.map(e => Number(e.value));
    setIsLoadingDownload(true);
    getDocumentsXlsxCsv(
      parametros.busca,
      parametros.orderBy,
      parametros.order,
      ids_tipos,
      tipoArquivo,
      {
        groups,
        headOffices,
        branches,
      },
    )
      .then(r => {
        if (r.data.size > 0) {
          const filename =
            r.headers['content-disposition'].match(/filename="(.+)"/)[1];
          download(new Blob([r.data], { type: r.data.type }), filename);
        } else {
          toast({
            title: r?.data?.error,
            description: 'Entre em contato para mais informações',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
      })
      .catch(async err => {
        // recuperando o erro do back
        // https://github.com/axios/axios/issues/3779
        const error2 = JSON.parse(await err.response.data.text());

        toast({
          title: `Erro`,
          description: error2.detail,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => setIsLoadingDownload(false));
  };

  const handleDownloadSelectedDocuments = async () => {
    setIsLoadingDownloadSelected(true);
    const request =
      documentosSelecionados.length > 1
        ? downloadSelectedDocuments(
            documentosSelecionados,
            {
              groups,
              headOffices,
              branches,
            },
            downloadAllDocuments,
          )
        : downloadDocument(documentosSelecionados[0]);

    request
      .then(r => {
        // se for processar o zip
        if (documentosSelecionados.length > 1) {
          apply(true, r.data.doc_uuid);
          toast({
            title: 'Downloading... ',
            description:
              'O arquivo está sendo preparado e será baixado em alguns instantes.',
            status: 'warning',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        } else {
          download(
            new Blob([r.data], { type: r.data.type }),
            r.headers['content-disposition'].match(/filename="(.+)"/)[1],
          );
        }
      })
      .catch(() => {
        toast({
          title: 'Documento não encontrado',
          description: 'Entre em contato para mais informações',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => {
        setIsLoadingDownloadSelected(false);
        clearDownloadAllDocuments();
      });
  };

  const onChangeSelecionarTodos = () => {
    setSelecionarTodosDocumentosPagina(!selecionarTodosDocumentosPagina);

    const lista = listaDocumentos.map(eq => {
      return { ...eq, selecionado: !selecionarTodosDocumentosPagina };
    });

    setListaDocumentos(lista);

    const documentos = lista?.filter(eq => eq.selecionado);
    setDocumentosSelecionados(documentos?.map(eq => eq.id_documento) ?? []);
  };

  const onChangeSelecionar = (item: DocumentsType) => {
    const lista = listaDocumentos.map(eq => {
      if (eq.id_documento === item.id_documento) {
        return { ...eq, selecionado: !eq.selecionado };
      }
      return eq;
    });
    setListaDocumentos(lista);

    const todosSelecionados = lista?.every(eq => eq.selecionado) ?? false;
    setSelecionarTodosDocumentosPagina(todosSelecionados);

    const documentos = lista?.filter(eq => eq.selecionado) ?? [];
    setDocumentosSelecionados(documentos?.map(eq => eq.id_documento) ?? []);
  };

  const clearDownloadAllDocuments = () => {
    setDocumentosSelecionados([]);
    const lista = listaDocumentos.map(eq => {
      return { ...eq, selecionado: false };
    });
    setListaDocumentos([...lista]);
    setSelecionarTodosDocumentosPagina(false);
    setDownloadAllDocuments(false);
  };

  const clearSelected = () => {
    refetch().then(() => {
      setDocumentosSelecionados([]);
      const lista = listaDocumentos.map(eq => {
        return { ...eq, selecionado: false };
      });
      setListaDocumentos([...lista]);
      setSelecionarTodosDocumentosPagina(false);
      setDownloadAllDocuments(false);
    });
  };

  const handleSelectedTypesChange = (changes: SelectItem[]) => {
    setSelectedTypes(changes);
    setParametros({
      ...parametros,
      pagina: '1',
    });
    updateUrlParams({ ...parametros, pagina: '1' }, history);
    queryClient.invalidateQueries('documentsList');
  };

  const handleTipoArquivo = (e: number) => {
    setTipoArquivo(e);
  };

  return (
    <Box px="8" py="4">
      <Heading>Documentos</Heading>
      <Flex pt={2} flexDir="column" w="100%">
        <Flex justify="space-between" py={5}>
          <HStack alignItems="end" gridGap={2}>
            <Stack>
              <Input
                name="search"
                type="text"
                icon={FiSearch}
                placeholder="Procure por ID, Nome, N° Doc Origem, Grupo ..."
                w={500}
                value={searchTmp}
                onChange={e => setSearchTmp(e.target.value)}
                fontSize="15px"
              />
            </Stack>
            <Stack w="20vw" maxW="20vw">
              <FormControl>
                <FormLabel fontSize="14px">Tipo</FormLabel>
                <MultiSelect
                  value={selectedTypes}
                  options={typeOptions || []}
                  onChange={(changes: SelectItem[]) =>
                    handleSelectedTypesChange(changes)
                  }
                  labelledBy="Selecione o tipo"
                  overrideStrings={MultiSelectStrings}
                  isLoading={isTypesLoading}
                />
              </FormControl>
            </Stack>
            {features.documentosDownloadCSVEnabled && (
              <Stack w="20vw" maxW="20vw">
                <FormControl>
                  <FormLabel fontSize="14px">Tipo de arquivo</FormLabel>
                  <RadioGroup
                    colorScheme="b"
                    value={tipoArquivo}
                    onChange={e => {
                      handleTipoArquivo(Number(e));
                    }}
                  >
                    <HStack gridGap={4}>
                      <Radio value={0}>Excel</Radio>
                      <Radio value={1}>CSV</Radio>
                    </HStack>
                  </RadioGroup>
                </FormControl>
              </Stack>
            )}
            <Stack minW="10%">{isFetching && <Spinner />}</Stack>
          </HStack>
          <HStack
            gridGap={2}
            justifyContent="space-between"
            alignItems="baseline"
          >
            <Button
              disabled={
                isLoadingDownload || isLoading || isLoadingDownloadSelected
              }
              onClick={handleDownload}
              color="black"
              background="transparent"
              border="1px solid black"
              style={{ marginTop: '20px' }}
            >
              Exportar
              {isLoadingDownload && <Spinner style={{ marginLeft: '10px' }} />}
            </Button>
            <Button
              disabled={
                isLoadingDownload ||
                isLoading ||
                isLoadingDownloadSelected ||
                isActive ||
                !(documentosSelecionados.length > 0)
              }
              onClick={handleDownloadSelectedDocuments}
              color="black"
              background="transparent"
              border="1px solid black"
              style={{ marginTop: '20px' }}
            >
              Baixar
              {isLoadingDownloadSelected && (
                <Spinner style={{ marginLeft: '10px' }} />
              )}
            </Button>
            {hasPermission && (
              <DocumentsForm clearSelected={clearSelected} isEdit={false} />
            )}
          </HStack>
        </Flex>
        {isLoading ? (
          <Flex justify="center">
            <Spinner />
          </Flex>
        ) : isError ? (
          <Flex justify="center">
            <Text>Falha ao obter dados dos documentos.</Text>
          </Flex>
        ) : !isLoading && !data?.results.length ? (
          <Flex justify="center">
            <Text>Não foi encontrado nenhum documento.</Text>
          </Flex>
        ) : (
          <>
            {(selecionarTodosDocumentosPagina || downloadAllDocuments) &&
              documentosSelecionados.length !== data?.count && (
                <Flex>
                  <Text>
                    <strong>
                      {downloadAllDocuments
                        ? data?.count
                        : documentosSelecionados.length}{' '}
                    </strong>
                    documentos selecionados.{' '}
                    <Text
                      onClick={() => {
                        setDownloadAllDocuments(!downloadAllDocuments);
                      }}
                      as="span"
                      cursor="pointer"
                      m="0px !important"
                      color="#3b61f9"
                      fontWeight="500"
                    >
                      {downloadAllDocuments
                        ? 'Deseja limpar seleção?'
                        : 'Deseja selecionar todos os documentos?'}
                    </Text>
                  </Text>
                </Flex>
              )}
            <Table>
              <Thead>
                <Tr>
                  <Th>
                    <Checkbox
                      colorScheme="b"
                      isChecked={
                        selecionarTodosDocumentosPagina || downloadAllDocuments
                      }
                      onChange={onChangeSelecionarTodos}
                      fontSize="sm"
                      isDisabled={
                        isLoadingDownload ||
                        isLoading ||
                        isLoadingDownloadSelected ||
                        isFetching
                      }
                    />
                  </Th>
                  <Th>ID</Th>
                  <Th>Grupo econômico</Th>
                  <Th>Matriz</Th>
                  <Th>Filial</Th>
                  <Th>Nome do documento</Th>
                  <Th>N° doc origem</Th>
                  <Th>
                    <Flex
                      gap={2}
                      cursor="pointer"
                      onClick={() => handleDocumentOrder('data_cadastro')}
                      alignItems="center"
                    >
                      Data{' '}
                      {getDirection('data_cadastro') === 'ASC' ? (
                        <ChevronDownIcon fontSize={14} ml="2" />
                      ) : (
                        <ChevronUpIcon fontSize={14} ml="2" />
                      )}
                    </Flex>
                  </Th>
                  <Th>
                    <Flex
                      gap={2}
                      cursor="pointer"
                      onClick={() =>
                        handleDocumentOrder('dh_ultimaatualizacao')
                      }
                      alignItems="center"
                    >
                      Última atualização{' '}
                      {getDirection('dh_ultimaatualizacao') === 'ASC' ? (
                        <ChevronDownIcon fontSize={14} ml="2" />
                      ) : (
                        <ChevronUpIcon fontSize={14} ml="2" />
                      )}
                    </Flex>
                  </Th>
                  <Th>Tipo</Th>
                  <Th>Usuário</Th>
                  <Th>Documento</Th>
                  <Th>Ações</Th>
                  <Td display={{ display: 'nome' }} />
                </Tr>
              </Thead>
              <Tbody>
                {listaDocumentos &&
                  listaDocumentos.map(documento => (
                    <Tr key={documento.id_documento}>
                      <Td>
                        <Checkbox
                          colorScheme="b"
                          isChecked={documento.selecionado}
                          onChange={() => {
                            onChangeSelecionar(documento);
                          }}
                          fontSize="sm"
                          isDisabled={
                            isLoadingDownload ||
                            isLoading ||
                            isLoadingDownloadSelected ||
                            isFetching
                          }
                        />
                      </Td>
                      <Td>
                        <Text>{documento.id_documento}</Text>
                      </Td>
                      <Td>
                        <Text>{documento.nm_grupoeconomico}</Text>
                      </Td>
                      <Td>
                        <Text>{documento.nm_matriz || '-'}</Text>
                        <Text>{documento.cnpj_matriz || '-'}</Text>
                      </Td>
                      <Td>
                        <Text>{documento.nm_filial || '-'}</Text>
                        <Text>{documento.cnpj_filial || '-'}</Text>
                      </Td>
                      <Td>
                        <Text>{documento.nome}</Text>
                      </Td>
                      <Td>
                        {documento.numero_documento_origem && (
                          <Text>{documento.numero_documento_origem}</Text>
                        )}
                        {documento.contratos.length === 1 && (
                          <Link
                            to={
                              documento.contratos[0]
                                ? `/portal/contracts/${documento.contratos[0].id_contrato}`
                                : ''
                            }
                            style={
                              documento.contratos[0]
                                ? { pointerEvents: 'auto' }
                                : { pointerEvents: 'none' }
                            }
                          >
                            <Text
                              fontWeight="bold"
                              _hover={{
                                color: 'gray.900',
                                textDecoration: 'underline',
                              }}
                            >
                              {documento.contratos[0]?.nu_contrato}
                            </Text>
                          </Link>
                        )}
                        {documento.contratos.length > 1 && (
                          <Menu>
                            <MenuButton fontWeight="bold" whiteSpace="nowrap">
                              {documento.contratos[0].nu_contrato}
                              <Icon as={FiChevronDown} fontSize="xl" ml={10} />
                            </MenuButton>
                            <MenuList>
                              {data &&
                                documento.contratos.map((n, i) => (
                                  <MenuGroup key={n.id_contrato}>
                                    <MenuItem
                                      onClick={() => routeChange(n.id_contrato)}
                                      fontWeight="bold"
                                    >
                                      {n.nu_contrato}
                                    </MenuItem>
                                    {documento.contratos.length !== i + 1 && (
                                      <MenuDivider />
                                    )}
                                  </MenuGroup>
                                ))}
                            </MenuList>
                          </Menu>
                        )}
                        {documento.modulo === 'Contrato' &&
                          !documento.contratos.length && <Text>-</Text>}
                      </Td>
                      <Td>
                        <Text>
                          {formatInTimeZone(
                            documento.data_cadastro,
                            'dd/MM/yyyy',
                          ) || '-'}
                        </Text>
                      </Td>
                      <Td>
                        <Text>
                          {formatInTimeZone(
                            documento.dh_ultimaatualizacao,
                            'dd/MM/yyyy HH:mm',
                            'America/Sao_Paulo',
                          ) || '-'}
                        </Text>
                      </Td>
                      <Td>
                        <Text>{documento.nome_tipo}</Text>
                      </Td>
                      <Td>
                        <Text>{documento.usuario}</Text>
                      </Td>
                      <Td>
                        <Tooltip label="Baixar Documento">
                          <IconButton
                            colorScheme="gray"
                            background="transparent"
                            _hover={{
                              background: 'transparent',
                            }}
                            aria-label="Send email"
                            icon={<Icon as={FiDownload} />}
                            onClick={() =>
                              handleDocumentDownload(documento.id_documento)
                            }
                          />
                        </Tooltip>
                      </Td>
                      <Td>
                        <Menu>
                          <MenuButton
                            as={IconButton}
                            aria-label="Options"
                            p={0}
                            style={{
                              borderColor: 'transparent',
                              background: 'none',
                            }}
                            _hover={{
                              borderColor: 'transparent',
                              background: 'none',
                            }}
                            icon={<Icon as={FiMoreVertical} fontSize="xl" />}
                            variant="outline"
                          />
                          <MenuList>
                            <DocumentsForm
                              isEdit
                              documents={documento}
                              clearSelected={clearSelected}
                            />
                            {hasPermission &&
                              hasNotPermissionRemove.indexOf(
                                documento.nome_tipo,
                              ) < 0 && (
                                <MenuItem
                                  onClick={() =>
                                    handleDialog(documento.id_documento)
                                  }
                                >
                                  Remover
                                </MenuItem>
                              )}
                          </MenuList>
                        </Menu>
                      </Td>
                      <Td display={{ display: 'nome' }} />
                    </Tr>
                  ))}
              </Tbody>
            </Table>
            <Flex justify="flex-end">
              <Pagination
                totalCountOfRegisters={data?.count || 0}
                currentPage={Number(parametros.pagina) ?? 1}
                onPageChange={pag => {
                  clearDownloadAllDocuments();
                  setParametros({
                    ...parametros,
                    pagina: pag.toString(),
                  });
                  updateUrlParams(
                    { ...parametros, pagina: pag.toString() },
                    history,
                  );
                }}
                onPageSizeChange={handlePageSizeChange}
                registersPerPage={Number(parametros.paginacao)}
              />
            </Flex>
          </>
        )}
      </Flex>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={undefined}
        onClose={onDialogClose}
        isOpen={isDialogOpen}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Atenção</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            Tem certeza que deseja excluir este item?
            <br />
            Esta ação não poderá ser desfeita.
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button onClick={onDialogClose} variant="secondary">
              Cancelar
            </Button>
            <Button ml={3} onClick={() => handleDelete()}>
              Confirmar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Box>
  );
};
